<template>
    <div class="wrapper">
        <div class="banner-preview">
            <img v-if="this.getImgUrl()" :src="require(`../assets/images/banner/${this.getImgUrl()}.png`)" alt="sale banner" class="responsive big-image">
            <img v-if="this.getImgUrl()" :src="require(`../assets/images/banner/${this.getImgUrl()}mobile.png`)" alt="sale banner" class="responsive mobile-image">

        </div>
    </div>
</template>

<script>
    export default {
        name: "sale-header",
        methods: {
            getImgUrl() {
                let currentDate = new Date().toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})
                let name = false
                let dates = [                                                                                                                                                                                // 12 AM - 3 AM + 1 day
                    { start: new Date(2019, 10, 17, 21).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}), end: new Date(2019, 10, 26, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})},
                    { start: new Date(2019, 10, 26, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'}), end: new Date(2019, 11, 8, 0).toLocaleString("en-US", {timeZone: 'America/Los_Angeles'})}
                ]

                dates.forEach(function(date, index) {
                    if ( currentDate >= date.start && currentDate <= date.end ) {
                        console.log("return");
                        name = (index+1) + 'banner'
                    }
                });

                return name
            },
        }
    }
</script>

<style lang="scss" scoped>

    .wrapper {
        padding-top: 20px;
        padding-bottom: 20px;
        display: grid;

        .banner-preview {
            position: relative;
            margin: 0 auto;

            img {
                width: 100%;
                max-height: 300px;
            }

            .mobile-image {
                display: none;
            }
            .big-image {
                display: block;
            }

            @media only screen and (max-width: 768px) {
                .mobile-image {
                    display: block;
                }

                .big-image {
                    display: none;
                }
            }
        }
    }
</style>